import Vue from 'vue'
import VueResource from 'vue-resource'
import settings from '@/settings'

Vue.use(VueResource)

let apiUrl = settings.apiUrl
let version = settings.version

export default {
  NOTIFICATIONS: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/dashboard/notifications`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // {'expires_in_seconds': float, 'message': str}
  ADD_GLOBAL_NOTIFICATION: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/dashboard/global-notifications`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  MARK_NOTIFICATIONS: ({ commit, dispatch }, ids) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/dashboard/notifications`, { ids: ids }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_NOTIFICATION: ({ commit, dispatch }, notificationId) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/dashboard/notifications/${notificationId}`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/notifications/actions.js